<style scoped lang="scss">
    .participation-list-wrap{
        height: calc(100% - 125px - 50px);
        overflow: auto;
    }
</style>
<template>
    <div   class="participant-list" :class="isMobile ? '' : 'window'">
        <ParticipationTournamentFilter></ParticipationTournamentFilter>

        <div class="tournament-title"><p>{{tournament.tnmtName}}</p></div>
        <div class="participation-list-wrap"  v-on:scroll="handleScroll" ref="participantList">
            <table class="participation-table" v-if="participants && participants.participantList.length > 0">
                <thead>
                <tr>
                    <th>종목</th>
                    <th>소속</th>
                    <th v-for="size in participants.playerSize">선수{{size}}</th>

                    <th width="100">총 {{participants.participantList.length}}건</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(participant) in participants.participantList">
                    <td>{{participant.eventName}} {{participant.age}} {{participant.level}}</td>
                    <td>{{participant.teamName}}</td>
                    <td v-for="size in participants.playerSize">
                        {{participant.playerList.length < size ? null : participant.playerList[size-1].playerName}}

                    </td>
                    <td><p class="player-detail" @click="participationDetailFunc(participant.participantId)" v-if="tournament.isTnmtTimeTablePublic">경기기록</p></td>
                </tr>
                </tbody>
            </table>
            <table class="participation-table" v-else>
                <thead>
                <tr>
                    <th>이름</th>
                    <th>소속</th>
                    <th width="100">총 0건</th>
                </tr>
                </thead>
                <tbody>

                <tr>
                    <td colspan="3" style="vertical-align: middle">
                        <div class="empty-list-wrap">
                            <div class="empty-list">
                                <div></div>
                                <p>검색결과가 없습니다.</p>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>


<script>
    import {mapState} from 'vuex'
    import ParticipationTournamentFilter from "./ParticipationTournamentFilter";


    export default {
        components: {ParticipationTournamentFilter},
        computed: {
            ...mapState('tournaments', ['tournament', 'participants']),
        },
        data() {
            return {
                tnmtId: this.$route.params.tnmtId,
                participantList: null,
            }
        },
        methods: {
            participationDetailFunc(participantId) {
                this.$router.push(`/tournament/${this.tournament.tnmtId}/participant/${participantId}`)

            },
            handleScroll(event){
                const scrollTop = event.target.scrollTop
                localStorage.setItem('TournamentPlayerList', scrollTop)
            },
        },
        created() {
            window.addEventListener('scroll', this.handleScroll)
        },
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll);
        },
        mounted() {

            if(localStorage.getItem('TournamentPlayerList')){

                if(this.$refs.participantList){

                    this.$refs.participantList.scrollTop = localStorage.getItem('TournamentPlayerList')
                }
            }

        },
    }
</script>
